import React, { Component } from 'react';
import axios from '~/axios';
import { connect } from 'react-redux';

import { Alert, Row } from 'antd';

import RegistrationForm from '../components/registration/RegistrationForm';

class Registration extends Component {
    constructor() {
        super();
        this.state = {
            // Load message directly from Server Side Rendered div so prevent a bad case of content shifting
            message: document.getElementById('message-ssr') ? document.getElementById('message-ssr').innerText : null,
            settings: document.getElementById('settings-ssr') ? JSON.parse(document.getElementById('settings-ssr').dataset.settings) : null,
            enableRegistration: false,
        }
    }

    componentDidMount() {
        this.updateRegistrationSettings();

        axios.get('/api/messages/1').then(({ data }) => {
            this.setState({ message: data.text });
        });
        axios.get('/api/settings').then(({ data }) => {
            this.setState({ settings: data }, () => {
                this.updateRegistrationSettings();
            });
        });
    }

    updateRegistrationSettings() {
        if (this.state.settings) {
            const registration_enabled = this.state.settings.find(x => x.name === 'registration_enabled')?.value;
            this.setState({ enableRegistration: registration_enabled || this.props.isAuthenticated })
        }
    }

    render() {
        const message = <div className="registration-message"
                             dangerouslySetInnerHTML={ { __html: this.state.message } }/>
        const alert = (this.state.message != null && this.state.message != ' ' && this.state.message != '') ?
            <Alert message="Notice" description={ message } type="warning" showIcon/> : '';

        const registrationEnabled = (
            <>
                <Row>
                    { alert }
                </Row>
                <RegistrationForm location={ this.props.location }/>
            </>
        )

        const registrationDisabled = (
            <>
                <Row>
                    <Alert message="Notice"
                           description="ROAR registration is currently closed to the public.  Please come back later."
                           type="warning" showIcon/>
                </Row>
            </>
        )

        return (
            <div>
                <h1>Registration</h1>

                {/* Show Registration only if user is logged in or public registration is enabled */ }
                { this.state.enableRegistration ?
                    registrationEnabled
                    : registrationDisabled }
            </div>
        );
    }
}

const mapStateToProps = state => {
    return { isAuthenticated: state.isAuthenticated }
}

export default connect(mapStateToProps)(Registration);
